import React, { useEffect, useState } from "react";
import data from './data.json';
import './ProductPage.scss';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import TopSectionComponent from "../../components/TopSectionComponent/TopSectionComponent.tsx";
import HowItWorksComponent from "../../components/HowItWorksComponent/HowItWorksComponent.tsx";
import { useCustomNavigation } from "../../utility/Utility.ts";
import { urlEndPoints } from "../../constants/constants.ts";
import JoinMovementComponent from "../../components/JoinMovementComponent/JoinMovementComponent.tsx";
import { ProductItemComponentProps } from "../../constants/interface.ts";
import KeyFeaturesComponent from "../../components/KeyFeaturesComponent/KeyFeaturesComponent.tsx";
import ProductBenefitsComponent from "../../components/ProductBenefitsComponent/ProductBenefitsComponent.tsx";
import UseCasesApplicationsComponent from "../../components/UseCasesApplicationsComponent/UseCasesApplicationsComponent.tsx";
import TaglineComponent from "../../components/TaglineComponent/TaglineComponent.tsx";
import WhyChooseProductComponent from "../../components/WhyChooseProductComponent/WhyChooseProductComponent.tsx";
import ProductServicesComponent from "../../components/ProductServicesComponent/ProductServicesComponent.tsx";

const ProductPage = () => {
    const { ProductList } = data;
    const {t} = useTranslation();
    const {productName: productUrlEndpoint} = useParams();
    const [currentProduct, setCurrentProduct] = useState<ProductItemComponentProps[]>(ProductList.__dummy);
    const customNavigate = useCustomNavigation();

    const handleSetCurrentProduct = () => {
        for( let key in urlEndPoints.product){
            if(urlEndPoints.product[key] === productUrlEndpoint){
                const currentProductData = ProductList[key];

                if(currentProductData){
                    setCurrentProduct(currentProductData);
                } else {
                    customNavigate(true, '/');
                }
            }
        }
    };

    useEffect(() => {
        handleSetCurrentProduct();
    }, [productUrlEndpoint]);

    console.log("currentProduct : ", currentProduct);

    return (
        <div>
            {
                currentProduct?.map((item: ProductItemComponentProps, index) => (
                    <React.Fragment key={index}>
                        {
                            RenderProductComponent(item, t)
                        }
                    </React.Fragment>
                ))
            }
        </div>
    );
};

const RenderProductComponent = (component: ProductItemComponentProps, t:any) => {
    const componentName = component.component || '';

    switch(componentName){
        case "TopSectionComponent":
            return (<TopSectionComponent
                title={component.title || ''}
                topText={'COMMON.INNOVII_PRODUCT'}
                topTextIcon={'☺️'}
                text={component.paragraph || ''}
                buttons={[]}
            />);
        case "TaglineComponent":
            return (<div className="section bg-light-gray-E9E">
                <TaglineComponent
                    title={component.title || ''}
                    paragraph={component.paragraph || ''}
                    img={component.img || ''}
                    imgClass={component.imgClass || ''}
                />
            </div>);
        case "KeyFeaturesComponent":
            return (<div className="section">
                <KeyFeaturesComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    img={component.img || ''}
                    list={component.list || []}
                    imgClass={component.imgClass || ''}
                />
            </div>);
        case "KeyFeaturesReverseComponent":
            return (<div className="section">
                <KeyFeaturesComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    img={component.img || ''}
                    list={component.list || []}
                    flexDirection="flex-row-reverse"
                    imgClass={component.imgClass || ''}
                />
            </div>);
        case "HowItWorksComponent":
            return (<div className="section">
                <HowItWorksComponent
                    title={component.title || ''}
                    img={component.img || ''}
                    list={component.list?.map(el => ({title: el.title || '', paragraph: el.paragraph || '', img: el.img || ''})) || []}
                    paragraph= {component.paragraph || ''}
                />
            </div>);
        case "WhyChooseProductComponent":
            return (<div className="section">
                <WhyChooseProductComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    list={component.list || []}
                />
            </div>);
        case "ProductBenefitsComponent":
            return (<div className="section">
                <ProductBenefitsComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    img={component.img || ''}
                    list={component.list || []}
                />
            </div>);
        case "ProductServicesComponent":
            return (<div className="section">
                <ProductServicesComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    list={component.list || []}
                />
            </div>);
        case "JoinTheMovementComponent":
            return (<div className="section">
                <JoinMovementComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    img={component.img || ''}
                    list={component.list?.map(el => ({paragraph: el.paragraph || ''})) || []}
                    appStoreList={[]}
                />
            </div>);
        case "UseCasesApplicationsComponent":
            return (<div className="section">
                <UseCasesApplicationsComponent
                    title={component.title || ''}
                    paragraph= {component.paragraph || ''}
                    img={component.img || ''}
                    list={component.list || []}
                />
            </div>);
        default:
            return <div></div>
    }
}

export default ProductPage;